var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGofoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 80,
    viewBox: "0 0 320 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,0) skewX(-10)",
    fill: "#FA5B0A"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 62,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 62,
    width: 62,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 36,
    width: 18,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 36,
    width: 30,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 0,
    width: 62,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 62,
    width: 62,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 0,
    width: 18,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 0,
    width: 18,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 0,
    width: 18,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 0,
    width: 58,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 32,
    width: 46,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 0,
    width: 62,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 62,
    width: 62,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 0,
    width: 18,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 0,
    width: 18,
    height: 80
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGofoLogo);
export default __webpack_public_path__ + "static/media/gofo-logo.d8867bb2aecb36f6a5ce467cf1deb102.svg";
export { ForwardRef as ReactComponent };